import { useState, useEffect } from 'react';
import axios from "axios";
import { Button } from 'antd';
import {
    VonageClient,
    ClientConfig,
    ConfigRegion,
    LoggingLevel
} from '@vonage/client-sdk';

function Vonage() {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [config] = useState(() => new ClientConfig(ConfigRegion.AP));
    const [client] = useState(() => {
        // Initialize client with optional config (default: ERROR logging, US region).
        const client = new VonageClient({
            loggingLevel: LoggingLevel.Warn,
            region: ConfigRegion.US
        });
        // Or update some options after initialization.
        client.setConfig(config);
        return client;
    });
    console.log('client1--------->', client);

    const [session, setSession] = useState();
    const [callId, setCallId] = useState(null);
    const [isCallActive, setIsCallActive] = useState(false);
    const [Ready, setReady] = useState(false);

    // Create Session as soon as client is available
    useEffect(() => {
        function get_user_id(new_flag = false) {
            let userId = localStorage.getItem('tele_user_id');
            console.log('userId--------->', userId);
            if (!userId || new_flag) {
                userId = 'ts' + Date.now();
                localStorage.setItem('tele_user_id', userId);
            }
            return userId;
        }

        const createSessionAsync = async (userId) => {
            console.log('UserId2--------->', userId);
            if (!userId) {
                alert('userId is not set');
                return;
            }
            console.log('useEffect client--------->', client);
            if (!client) return;

            try {
                // 토큰 발급 + phone number 받기
                const response = await axios.post('/api/get_jwt', {username: userId});
                console.log('response--------->', response);
                if (response.data.success) {
                    const token = response.data.jwt;
                    setPhoneNumber(response.data.phone_number);
                    const session = await client.createSession(token);
                    console.log('after createSession --------->', session);
                    setSession(session);
                    setReady(true);
                    } 
                else {
                    setReady(false);
                    alert('Error creating session:', response.data.error);
                }

            } catch (error) {
                console.error("Error creating session:", error);
                alert('Error creating session:', error);
            }
        };

        const userId = get_user_id();
        console.log('userId1--------->', userId);
        createSessionAsync(userId);
        //setUserId(userId);
    }, [client]);

    const startCall = async () => {
        if (client) {
            try {
                const callId = await client.serverCall({ to: phoneNumber });
                console.log("Call to application started", callId);
                // call 객체 저장 및 통화 상태 활성화
                setCallId(callId);
                setIsCallActive(true);
            } catch (error) {
                console.error("Call Failed:", error);
            }
        }
    };

    // 통화 종료 함수 추가
    const endCall = async () => {
        if (client && callId) {
            try {
                await client.hangup(callId);
                console.log("Call ended");
                setCallId(null);
                setIsCallActive(false);
            } catch (error) {
                console.error("End Call Failed:", error);
            }
        }
    };

    // DTMF 신호 전송 함수 추가
    const sendDTMF = async (digit) => {
        if (client && callId && isCallActive) {
            try {
                await client.sendDTMF(callId, digit);
                console.log(`DTMF signal sent: ${digit}`);
            } catch (error) {
                console.error("Failed to send DTMF:", error);
            }
        }
    };

    const disabled = !Ready || !client || !session;

    // 키패드 버튼 스타일
    const keypadButtonStyle = {
        width: '60px',
        height: '60px',
        margin: '5px',
        fontSize: '20px',
        borderRadius: '30px',
        border: '1px solid #ddd',
        backgroundColor: '#fff',
        cursor: isCallActive ? 'pointer' : 'not-allowed',
        opacity: isCallActive ? 1 : 0.6
    };

    return (
        <div style={{ padding: '20px', textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
            <h2 style={{ color: '#4CAF50' }}>Vonage WebRTC 연결 상태: {isCallActive ? '통화중' : '대기중'}</h2>
            <h2 style={{ color: '#2196F3' }}>phoneNumber: {phoneNumber}</h2>
            {!isCallActive ? (
                <Button 
                    onClick={startCall} 
                    variant="solid"
                    disabled={disabled}
                    style={{
                        padding: '10px 20px',
                        fontSize: '16px',
                        color: '#fff',
                        backgroundColor: disabled ? '#ccc' : '#4CAF50',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        margin: '10px'
                    }}
                >
                    WebRTC 통화 시작
                </Button>
            ) : (
                <Button 
                    onClick={endCall} 
                    variant="solid"
                    disabled={!callId}
                    style={{
                        padding: '10px 20px',
                        fontSize: '16px',
                        color: '#fff',
                        backgroundColor: '#f44336',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        margin: '10px'
                    }}
                >
                    통화 종료
                </Button>
            )}

            {/* 키패드 추가 */}
            <div style={{ 
                maxWidth: '240px', 
                margin: '20px auto',
                padding: '15px',
                backgroundColor: '#f5f5f5',
                borderRadius: '10px'
            }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '5px' }}>
                    {['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'].map((digit) => (
                        <Button
                            key={digit}
                            onClick={() => sendDTMF(digit)}
                            disabled={!isCallActive}
                            style={keypadButtonStyle}
                        >
                            {digit}
                        </Button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Vonage;